import { render } from "./AgentePickDepto.vue?vue&type=template&id=4091d169"
import script from "./AgentePickDepto.vue?vue&type=script&lang=ts"
export * from "./AgentePickDepto.vue?vue&type=script&lang=ts"
script.render = render

export default script